// A API retorna números e strings SQL com ponto decimal; textos locais usam vírgula.
export function valorMonetario(valor) {
  if (typeof valor === 'number') return Number.isFinite(valor) ? valor : 0;
  let texto = String(valor ?? '').replace(/[^\d,.-]/g, '');
  if (!texto) return 0;
  if (texto.includes(',')) texto = texto.replace(/\./g, '').replace(',', '.');
  else if (/^-?\d{1,3}(\.\d{3})+$/.test(texto)) texto = texto.replace(/\./g, '');
  const numero = Number(texto);
  return Number.isFinite(numero) ? numero : 0;
}
